var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsVendorManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.99999V2.66666H13.3333V3.99999H2.66667ZM2.66667 13.3333V9.33332H2V7.99999L2.66667 4.66666H13.3333L14 7.99999V9.33332H13.3333V13.3333H12V9.33332H9.33333V13.3333H2.66667ZM4 12H8V9.33332H4V12ZM3.36667 7.99999H12.6333L12.2333 5.99999H3.76667L3.36667 7.99999Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVendorManagement);
export default __webpack_public_path__ + "static/media/icons-vendor-management.6674e8aa.svg";
export { ForwardRef as ReactComponent };